<div class="container-fluid" style="margin-top: 70px">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-sm-12 col-xs-12 xl-12">
      <div class="bg-white pt-3 pb-3 animated fadeIn">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="flex justify-between items-start">
                <div>
                  <h5 class="section-header">
                    COURSE REGISTRATION<small
                      class="text-rd1000"
                      *ngIf="isPenaltyPeriod == 'yes'"
                      >(with penalty)</small
                    ><small class="text-rd1000" *ngIf="isCourseRegClosed"
                      >(closed)</small
                    ><br /><small
                      *ngIf="!isCourseRegClosed && isPenaltyPeriod == 'no'"
                    ></small>
                  </h5>
                  <p>
                    <small
                      >Penalty: {{ penaltyStarts }} | Closure:
                      {{ courseRegEnds }}
                    </small>
                  </p>
                </div>

                <div class="flex gap-3">
                  <button
                    mat-raised-button
                    [matMenuTriggerFor]="receipt"
                    *ngIf="courseRegPayments[0]"
                    color="primary"
                  >
                    Print Receipt
                  </button>
                  <mat-menu class="mt-2" #receipt="matMenu">
                    <button
                      (click)="printReceipt(pay)"
                      mat-menu-item
                      *ngFor="let pay of courseRegPayments"
                    >
                      <span class="text-sm flex items-center gap-2">
                        <span
                          class="block h-2 w-2 min-w-2 rounded-full {{
                            pay.status == 'failed' || pay.status == 'rejected'
                              ? 'bg-red-700'
                              : pay.status == 'pending'
                              ? 'bg-orange-300'
                              : 'bg-green-500'
                          }}"
                        ></span>
                        <span>Ref: {{ pay.reference }}</span>
                      </span>
                    </button>
                  </mat-menu>

                  <button mat-raised-button color="primary" (click)="print()">
                    Print Course(s)
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid" style="padding-top: 0">
          <div class="row">
            <!-- error div -->
            <div
              class="ml-3"
              *ngIf="isActivated == null || isPenaltyPeriod == 'null'"
            >
              Loading...
            </div>
            <div *ngIf="isPenaltyPeriod == 'yes'" class="col-md-12">
              <p>
                Due to lateness in registration, you are required to make a
                penalty fee of
                <b>{{
                  totalPenaltyFee | currency : "NGN" : "symbol-narrow"
                }}</b>
                <br />
                Fee: {{ penaltyFee | currency : "NGN" : "symbol-narrow" }},
                Charge: {{ charge | currency : "NGN" : "symbol-narrow" }}
              </p>

              <ng-interswitch
                *ngIf="paymentGateway.includes('interswitch')"
                [paymentOptions]="interswitchOptions"
                (paymentCallback)="handlePaymentInterswitch($event)"
                [class]="'btn btn-primary mt-2'"
              >
                Pay with Interswitch
              </ng-interswitch>

              <button
                type="button"
                [disabled]="initiating"
                class="mt-2"
                *ngIf="paymentGateway.includes('paystack')"
                mat-raised-button
                (click)="handlePenaltyPayment()"
              >
                {{ initiating ? "Loading..." : "Pay with Paystack" }}
              </button>
            </div>
            <div class="ml-3" *ngIf="isActivated == 'not-activated'">
              <p>Technical Error</p>
            </div>
          </div>
        </div>

        <div
          class="container-fluid"
          style="background-color: #f8f8f8; padding-top: 0; margin-top: 0"
          *ngIf="
            isActivated == 'activated' &&
            !isCourseRegClosed &&
            isPenaltyPeriod == 'no'
          "
        ></div>
        <form
          [formGroup]="courseRegForm"
          (ngSubmit)="addCourses(courseRegForm.value)"
        >
          <div
            class="container-fluid"
            style="padding-top: 0; margin-top: 0"
            *ngIf="isActivated == 'activated'"
          >
            <div class="row">
              <div class="col-12" style="position: relative; top: -10px">
                <div
                  class="container-fluid"
                  *ngIf="!isCourseRegClosed && isPenaltyPeriod == 'no'"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <p [style.display]="responseExists ? 'none' : 'block'">
                        <small>{{ cresponse }}</small>
                      </p>
                      <small *ngIf="!scloaded">Loading...</small>
                    </div>
                  </div>
                  <!-- List of Registered Courses Table -->
                  <table
                    *ngIf="responseExists"
                    class="table table-auto text-center text-[12px] md:text-[14px]"
                  >
                    <thead>
                      <tr>
                        <th class="px-0">S/N</th>
                        <th class="px-0">Course Title</th>
                        <th
                          class="px-0"
                          *ngIf="payperbyte == 0 || payperbyte == 2"
                        >
                          Description
                        </th>
                        <th class="px-0">Units</th>
                        <th class="px-0">Action</th>
                      </tr>
                    </thead>
                    <tbody
                      *ngFor="
                        let course of registeredSemesterCourses;
                        index as i
                      "
                    >
                      <tr>
                        <td>{{ i + 1 }}</td>
                        <td>
                          <button
                            class="border"
                            (click)="joinVirtualClass(course)"
                          >
                            VC
                          </button>
                          <a
                            class="hover:no-underline"
                            [routerLink]="
                              course.evaluated == 'N' &&
                              '/home/staff-evaluation/:{{
                  course.sub_id
                }}/:{{ course.co_id }}/:{{ course.r_id }}'
                            "
                          >
                            {{ course.title }}
                          </a>
                        </td>
                        <td *ngIf="payperbyte == 0 || payperbyte == 2">
                          {{ course.s_desc | uppercase }}
                        </td>
                        <td>{{ course.unit }}</td>
                        <td *ngIf="payperbyte == 0 || payperbyte == 2">
                          <button
                            type="button"
                            [disabled]="readOnly"
                            title="delete"
                            (click)="
                              deleteCourse(
                                course.title,
                                course.sub_id + ',' + course.termd_id
                              )
                            "
                          >
                            <mat-icon class="text-rd1000">delete</mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="flex justify-between">
                    <h6>Total Units: {{ totalUnits }}</h6>
                    <!-- <button
          type="button"
          color="primary"
          matTooltip="Print"
          (click)="print()"
        >
          <mat-icon>print</mat-icon>
        </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="fixed bottom-0 w-screen"
            *ngIf="isActivated == 'activated'"
          >
            <div
              *ngIf="!isCourseRegClosed && isPenaltyPeriod == 'no'"
              class="flex justify-center flex-wrap bg-white shadow-sm p-3 md:w-[82%] w-[93vw]"
            >
              <div class="col-10">
                <mat-form-field style="text-transform: uppercase">
                  <mat-select
                    placeholder="Department Courses"
                    [disabled]="readOnly"
                    style="font-size: 0.9em"
                    name="selectedCourses"
                    formControlName="selectedCourses"
                    multiple
                    id="deptco"
                  >
                    <mat-option
                      style="text-transform: uppercase"
                      *ngFor="let course of deptCourses"
                      value="{{ course.sub_id }}"
                      >{{
                        course.title +
                          "(" +
                          course.s_desc +
                          ")" +
                          " - " +
                          course.unit +
                          " units "
                      }}</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div>
                <button
                  type="submit"
                  [disabled]="readOnly"
                  mat-raised-button
                  color="primary"
                >
                  Add Course(s)
                </button>
              </div>

              <div class="col-12">
                <div class="row" *ngIf="extra_co == 'Y'">
                  <div
                    class="col-10"
                    *ngIf="payperbyte == 0 || payperbyte == 2"
                  >
                    <ng-select
                      [items]="allCourses"
                      bindLabel="course_unit"
                      bindValue="co_id"
                      placeholder="Extra Courses(Strictly for borrowed or carried courses only)"
                      formControlName="search"
                      (change)="getSearchValue()"
                      style="text-transform: uppercase"
                      [disabled]="readOnly"
                    >
                    </ng-select>
                  </div>
                  <div class="col-2" *ngIf="payperbyte == 0 || payperbyte == 2">
                    <button
                      type="button"
                      [disabled]="readOnly"
                      mat-raised-button
                      (click)="addExtraCourses()"
                      mat-raised-button
                    >
                      Add Extra
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div id="receipt" *ngIf="courseRegPayments[0]" class="hidden">
  <body>
    <div
      style="
        height: 95vh;
        font-size: 1.1rem;
        max-width: 75rem;
        margin: 1rem auto;
        display: flex;
        flex-direction: column;
        gap: 2rem;
        padding: 2rem 1rem 0;
        font-family: sans-serif;
      "
    >
      <img
        style="
          position: absolute;
          height: 18rem;
          z-index: -10;
          opacity: 0.1;
          right: 0;
          top: 0;
        "
        [src]="company_logo"
      />
      <div style="display: flex; align-items: center; gap: 1rem">
        <img style="width: 3rem" [src]="company_logo" alt="Company Logo" />
        <div style="display: flex; flex-direction: column; font-size: 1.15rem">
          <h3>{{ company_name | uppercase }}</h3>
          <div [innerHTML]="company_address"></div>
        </div>
      </div>

      <b
        style="
          color: #1a237e;
          font-size: 1rem;
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #ccc;
          padding: 1rem 0;
        "
      >
        COURSE REGISTRATION PAYMENT RECEIPT
      </b>

      <div style="display: flex; align-items: center; gap: 1rem">
        <img
          style="height: 9rem; object-fit: cover; border-radius: 0.3rem"
          [src]="studentData?.passport"
          alt="Passport Missing"
        />
        <div class="details-box-container">
          <div>
            <span>Student Name:</span>
            <div>
              <b>{{ studentData?.lastname | uppercase }}</b>
              {{ studentData?.firstname | uppercase }}
              <span *ngIf="studentData?.middlename">{{
                studentData?.middlename | uppercase
              }}</span>
            </div>
          </div>
          <div>
            <span>Student ID.:</span>
            <b>{{ studentData?.matric_no }}</b>
          </div>
          <div>
            <span>Gender:</span>
            <b>{{ studentData?.gender | uppercase }}</b>
          </div>
          <div>
            <span>Class:</span>
            <b
              >{{ studentData?.category | uppercase }} -
              {{ studentData?.name | uppercase }} -
              {{ studentData?.tag | uppercase }}</b
            >
          </div>
        </div>
      </div>

      <div>
        <p
          style="
            font-size: 1rem;
            border-top: 0.5px solid #ccc;
            border-bottom: 0.5px solid #ccc;
            padding: 0.8rem 0;
          "
        >
          Payment Summary
        </p>

        <div class="details-box-container" style="margin-top: 1rem">
          <div>
            <span>Amount:</span>
            <div>
              <b>{{
                receiptData?.amount | currency : "NGN" : "symbol-narrow"
              }}</b>
            </div>
          </div>
          <div>
            <span>Date:</span>
            <div>
              <b>{{
                receiptData?.created_at | date : "MMM d, y, h:mm:ss a"
              }}</b>
            </div>
          </div>
          <div>
            <span>Status:</span>
            <div>
              <b style="text-transform: capitalize">{{
                receiptData?.status
              }}</b>
            </div>
          </div>
          <div>
            <span>Reference:</span>
            <div>
              <b>{{ receiptData?.reference }}</b>
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          font-size: 0.65rem;
          margin-top: auto;
          color: #333;
          display: flex;
          justify-content: end;
          gap: 0.5rem;
          align-items: center;
        "
      >
        Powered By
        <a target="_blank" href="https://edozzier.com/">
          <img
            style="height: 1rem; display: inline"
            src="https://edossier.app/admin/assets/img/edozzier-log.png"
          />
        </a>
      </div>
    </div>
  </body>
</div>

<!-- <div class="fixed bottom-24 right-8">
<button
  type="button"
  color="primary"
  matTooltip="Print"
  class="mat-fab"
  mat-button
  (click)="print()"
>
  <mat-icon>print</mat-icon>
</button>
</div> -->
